var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgToggleMenuTablet = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu (tablet) 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 213",
    d: "M26.3801 12H10.23C9.44304 12 8.80505 12.6716 8.80505 13.5C8.80505 14.3284 9.44304 15 10.23 15H26.3801C27.1671 15 27.8051 14.3284 27.8051 13.5C27.8051 12.6716 27.1671 12 26.3801 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 214",
    d: "M21.4052 26H10.205C9.43181 26 8.80505 26.6716 8.80505 27.5C8.80505 28.3284 9.43181 29 10.205 29H21.4052C22.1783 29 22.8051 28.3284 22.8051 27.5C22.8051 26.6716 22.1783 26 21.4052 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 215",
    d: "M31.3651 19H10.245C9.44975 19 8.80505 19.6716 8.80505 20.5C8.80505 21.3284 9.44975 22 10.245 22H31.3651C32.1604 22 32.8051 21.3284 32.8051 20.5C32.8051 19.6716 32.1604 19 31.3651 19Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToggleMenuTablet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/toggle-menu-tablet.02684d04.svg";
export { ForwardRef as ReactComponent };